module.exports = __webpack_public_path__ + "assets/img/newsIconBg.2ad119da.png";